<ng-template #quantityValidationModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title" id="modal-basic-title" translate>CREATING_RETURN_HEADER</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">×</span>
    </button>
  </div>
  <div class="modal-body">
    <div *ngIf="!returnResultReceived">
      <p translate>CREATING_RETURN_INFO</p>
      <div
        class="progress-bar progress-bar-striped progress-bar-animated bg-primary"
        role="progressbar"
        aria-valuenow="75"
        aria-valuemin="0"
        aria-valuemax="100"
        style="width: 75%; height: 10px"
      ></div>
    </div>

    <div *ngIf="returnResultReceived">
      <div *ngIf="!errorCreatingReturn">
        <p translate>SUCCESFULLY_CREATED_RETURN</p>
        <span translate>SHIPMENT_PRINTS</span>
        <span *ngFor="let shipmentPrint of checkout.extra.shipmentPrints">
          <a (click)="openShipmentPdfNewWindow(shipmentPrint)">
            {{ shipmentPrint.id }}
          </a>
        </span>
      </div>
      <div *ngIf="errorCreatingReturn">
        <p translate>ERROR_CREATING_RETURN</p>
        <pre>
          {{ errors | json }}
        </pre>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      *ngIf="returnResultReceived && !errorCreatingReturn"
      type="button"
      class="btn btn-primary"
      (click)="modal.close(VALIDATION_DONE)"
      translate
    >
      OK
    </button>
    <button
      *ngIf="returnResultReceived && errorCreatingReturn"
      type="button"
      class="btn btn-primary"
      (click)="modal.close('Go Back')"
      translate
    >
      BACK
    </button>
  </div>
</ng-template>
